export class RestoreResult {
    'awsEc2Instance';
    'awsEc2Ami';
    'awsEbsVolume';
    'awsEbsSnapshot';
    'azureDisk';
    'azureVmInstance';
    'gcpVmInstance';
    'recordRestore';
    'eksNamespaceRestore';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsEc2Instance",
            "baseName": "awsEc2Instance",
            "type": "AwsEc2InstanceRestoreResult",
            "format": ""
        },
        {
            "name": "awsEc2Ami",
            "baseName": "awsEc2Ami",
            "type": "AwsEc2AmiConvertResult",
            "format": ""
        },
        {
            "name": "awsEbsVolume",
            "baseName": "awsEbsVolume",
            "type": "AwsEbsVolumeRestoreResult",
            "format": ""
        },
        {
            "name": "awsEbsSnapshot",
            "baseName": "awsEbsSnapshot",
            "type": "AwsEbsSnapshotConvertResult",
            "format": ""
        },
        {
            "name": "azureDisk",
            "baseName": "azureDisk",
            "type": "AzureDiskRestoreResult",
            "format": ""
        },
        {
            "name": "azureVmInstance",
            "baseName": "azureVmInstance",
            "type": "AzureVmInstanceRestoreResult",
            "format": ""
        },
        {
            "name": "gcpVmInstance",
            "baseName": "gcpVmInstance",
            "type": "GcpVmInstanceRestoreResult",
            "format": ""
        },
        {
            "name": "recordRestore",
            "baseName": "recordRestore",
            "type": "RecordRestoreResult",
            "format": ""
        },
        {
            "name": "eksNamespaceRestore",
            "baseName": "eksNamespaceRestore",
            "type": "EksNamespaceRestoreResult",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreResult.attributeTypeMap;
    }
    constructor() {
    }
}
